/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ number: NonNullable<unknown> }} Earth_Day_2025_Impact_Land_DescriptionInputs */

const en_earth_day_2025_impact_land_description = /** @type {(inputs: Earth_Day_2025_Impact_Land_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`That’s the size of 
${i?.number} parking spot(s).`)
};

const ar_earth_day_2025_impact_land_description = /** @type {(inputs: Earth_Day_2025_Impact_Land_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`هذا هو حجم 
${i?.number} من مواقف السيارات.`)
};

const de_earth_day_2025_impact_land_description = /** @type {(inputs: Earth_Day_2025_Impact_Land_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Das ist die Größe von 
${i?.number} Parkplätzen.`)
};

const es_earth_day_2025_impact_land_description = /** @type {(inputs: Earth_Day_2025_Impact_Land_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ese es el tamaño de 
${i?.number} de plazas de aparcamiento.`)
};

const fr_earth_day_2025_impact_land_description = /** @type {(inputs: Earth_Day_2025_Impact_Land_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cela représente l'équivalent de ${i?.number} places de stationnement.`)
};

const it_earth_day_2025_impact_land_description = /** @type {(inputs: Earth_Day_2025_Impact_Land_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rappresenta la dimensione di 
${i?.number} posti auto.`)
};

const ja_earth_day_2025_impact_land_description = /** @type {(inputs: Earth_Day_2025_Impact_Land_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`車${i?.number}台分の駐車スペース
に相当します`)
};

const ko_earth_day_2025_impact_land_description = /** @type {(inputs: Earth_Day_2025_Impact_Land_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`주차장 ${i?.number}개
면적과 동일해요.`)
};

const pt_br_earth_day_2025_impact_land_description = /** @type {(inputs: Earth_Day_2025_Impact_Land_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esse é o tamanho de
${i?.number} vagas de estacionamento.`)
};

const ru_earth_day_2025_impact_land_description = /** @type {(inputs: Earth_Day_2025_Impact_Land_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Это размер 
${i?.number} парковочных мест.`)
};

const th_earth_day_2025_impact_land_description = /** @type {(inputs: Earth_Day_2025_Impact_Land_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`นั่นมีขนาดเทียบเท่า
กับที่จอดรถ ${i?.number} คัน`)
};

const tr_earth_day_2025_impact_land_description = /** @type {(inputs: Earth_Day_2025_Impact_Land_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bu, ${i?.number} park yeri
büyüklüğünde.`)
};

const zh_cn_earth_day_2025_impact_land_description = /** @type {(inputs: Earth_Day_2025_Impact_Land_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`相当于
${i?.number} 个停车格大小`)
};

const zh_tw_earth_day_2025_impact_land_description = /** @type {(inputs: Earth_Day_2025_Impact_Land_DescriptionInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`相當於
${i?.number} 個停車格大小`)
};

/**
* | output |
* | --- |
* | "That’s the size of {number} parking spot(s)." |
*
* @param {Earth_Day_2025_Impact_Land_DescriptionInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const earth_day_2025_impact_land_description = /** @type {((inputs: Earth_Day_2025_Impact_Land_DescriptionInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Earth_Day_2025_Impact_Land_DescriptionInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_earth_day_2025_impact_land_description(inputs)
	if (locale === "ar") return ar_earth_day_2025_impact_land_description(inputs)
	if (locale === "de") return de_earth_day_2025_impact_land_description(inputs)
	if (locale === "es") return es_earth_day_2025_impact_land_description(inputs)
	if (locale === "fr") return fr_earth_day_2025_impact_land_description(inputs)
	if (locale === "it") return it_earth_day_2025_impact_land_description(inputs)
	if (locale === "ja") return ja_earth_day_2025_impact_land_description(inputs)
	if (locale === "ko") return ko_earth_day_2025_impact_land_description(inputs)
	if (locale === "pt_br") return pt_br_earth_day_2025_impact_land_description(inputs)
	if (locale === "ru") return ru_earth_day_2025_impact_land_description(inputs)
	if (locale === "th") return th_earth_day_2025_impact_land_description(inputs)
	if (locale === "tr") return tr_earth_day_2025_impact_land_description(inputs)
	if (locale === "zh_cn") return zh_cn_earth_day_2025_impact_land_description(inputs)
	return zh_tw_earth_day_2025_impact_land_description(inputs)
});